/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */
// eslint-disable-next-line no-undef
const { v4: uuidv4 } = require('uuid');

/**
 * Add timely alerts.
 */
export const ADD_TIMELY_ALERTS = 'ADD_TIMELY_ALERTS';
export const addTimelyAlerts = (alerts) => {
  return {
    alerts,
    type: ADD_TIMELY_ALERTS
  };
};

/**
 * Remove timely alerts with the given id.
 */
export const REMOVE_TIMELY_ALERT = 'REMOVE_TIMELY_ALERT';
export const removeTimelyAlert = (id) => {
  return {
    type: REMOVE_TIMELY_ALERT,
    id
  };
};

/**
 * Remove timely alerts with the given id.
 */
export const REMOVE_PAGE_TIMELY_ALERTS = 'REMOVE_PAGE_TIMELY_ALERTS';
export const removePageTimelyAlerts = (page) => {
  return {
    type: REMOVE_PAGE_TIMELY_ALERTS,
    page
  };
};

/**
 * TimelyAlert builder.
 * @param messageText
 * @param page
 * @returns {{messageText: *, id: string, page: *}}
 */
export const createTimelyAlert = (messageText, page) => {
  return {
    id: uuidv4(),
    messageText,
    page
  };
};
